import {formatDate} from "@angular/common";
import {trackEvent} from '@farmnet/tag-manager';

import { saveAs } from 'file-saver';

import fieldImportWizardTemplate from '../wizards/fieldImportWizard.html';

angular.module('cfn').controller('fieldCoreController', fieldCoreController);

fieldCoreController.$inject = [
  '$scope',
  '$rootScope',
  'CoreREST',
  'Field',
  '$http',
  '$timeout',
  '$log',
  '$dialog',
  '$injector',
  '$route',
  'FavoriteService',
  'i18nFilter',
  'fields.fieldService',
  'farmnet.FeatureToggleService',
  '$location',
  'tracker'
];

function fieldCoreController(
  $scope,
  $rootScope,
  CoreREST,
  Field,
  $http,
  $timeout,
  $log,
  $dialog,
  $injector,
  $route,
  FavoriteService,
  i18nFilter,
  fieldService,
  featureToggle,
  $location,
  tracker
) {
  let ctrl = this;

  let mode = {
    name: 'field',
    mapView: true,
    hasActive: true
  };

  ctrl.notes = undefined;
  ctrl.fieldBiodiversityData = undefined;
  ctrl.defaultFieldBiodiversityData = {
    biodiversityType: 'EMPTY',
    fruitTreeCount: undefined,
    endemicTreeCount: undefined,
    biodiversityNotes: ''
  };

  ctrl.isSwissBartoUser = app.credentials.company.countryIsoCode === 'CHE';

  ctrl.fieldImportWizardTemplate = fieldImportWizardTemplate;

  ctrl.fieldEnvironmentData = require('./fieldEnvironmentData.html');
  ctrl.fieldEnvironmentDataBarto = require('./fieldEnvironmentDataBarto.html');

  ctrl.claasTelematics = () => {
    if (arrayContains('APDIFIELDSYNC', app.credentials.licensedProducts)) {
      tracker.trackEvent('CLAAS Telematics Button clicked', 'iFrame');
      $location.path('/connect/apdi-field-sync');
    } else {
      tracker.trackEvent('CLAAS Telematics Button clicked', 'Shop');
      $location.path('/shop/components/APDIFIELDSYNC');
    }
  };

  ctrl.summary = {
    show: false,
    title: i18nFilter('fe.common.words.summary', 'Summary'),
    countSucceeded: 0,
    totalCount: 0,
    failedInfos: null,
    reset: function() {
      ctrl.summary.show = false;
      ctrl.summary.countSucceeded = 0;
      ctrl.summary.totalCount = 0;
      ctrl.summary.failedInfos = null;
    }
  };

  ctrl.confirmDelete = {
    show: false,
    title: i18nFilter(
      'fe.common.message.reallyDelete.title',
      'Confirm Deletion'
    ),
    message: i18nFilter(
      'fe.common.message.reallyDelete.batch.message',
      'Are you sure you want to delete this items?'
    )
  };

  ctrl.confirmDeleteFieldBoundaries = {
    show: false,
    title: i18nFilter(
      'fe.common.message.reallyDelete.title',
      'Confirm Deletion'
    ),
    message: i18nFilter(
      'fe.common.message.reallyDeleteFieldBoundaries.message',
      'Are you sure you want to delete field boundaries?'
    )
  };

  ctrl.getEntityName = function() {
    try {
      return $scope.details.field.name;
    } catch (e) {
      return '';
    }
  };

  ctrl.editFieldWithToolbox = function() {
    if (!$scope.details.field.id) {
      // if new field was created, wait for autosave until new id was set
      $scope.$watch('details.field.id', function(newValue, oldValue) {
        if (newValue) {
          $location.path('/geo-service/field/edit/' + newValue);
        }
      });
    } else {
      $location.path('/geo-service/field/edit/' + $scope.details.field.id);
    }
  };

  ctrl.deleteFieldBoundaries = function () {
    $http.delete('/365FarmNet/mod/fields/rest/v1.0/fields/modify/geometry/' + $scope.details.field.id)
        .then(() => {
          $scope.details.field.geometry = undefined;
          $scope.details.field.geoArea = undefined;
          ctrl.confirmDeleteFieldBoundaries.show = false;
        });
  };

  ctrl.updateFieldBoundaries = function() {
    ctrl.resetDetails(true, true);
  };

  ctrl.getField = function() {
    if ($scope.details && $scope.details.field) {
      return $scope.details.field;
    }
    return;
  };

  ctrl.deleteField = function() {
    $dialog
      .messageBox(
        i18nFilter('fe.common.delete', 'Delete'),
        i18nFilter('fe.common.areYouSure', 'Are you sure?'),
        [
          { result: 'cancel', label: i18nFilter('fe.common.cancel', 'Cancel') },
          {
            result: 'ok',
            label: i18nFilter('fe.common.ok', 'OK'),
            cssClass: 'btn-primary'
          }
        ]
      )

      .open()
      .then(function(response) {
        if (response === 'ok') {
          performFieldDeletion(ctrl.details.field.id);
        }
      });
  };

  ctrl.selectedFieldsCount = function() {
    return getSelectedFields().length;
  };

  ctrl.deleteSelectedFields = function() {
    // hide delete confirmation popup
    ctrl.confirmDelete.show = false;

    ctrl.summary.reset();

    // get ids of selected fields
    let selectedFieldIds = getSelectedFields();

    app.showLoader();
    fieldService
      .deleteFields(selectedFieldIds)
      .then(function(response) {
        if (response.data) {
          $rootScope.$emit(
            'deleteFields',
            getDeletedIds(selectedFieldIds, response.data.failed)
          );
          ctrl.summary.show = true;
          ctrl.summary.totalCount = selectedFieldIds.length;
          ctrl.summary.countSucceeded = response.data.deletedCount;
          ctrl.summary.failedInfos = createSummaryInformation(
            response.data.failed
          );
        }
      })
      .catch(function(error) {
        $rootScope.alertController.addTemporaryAlert(error.message, 'error');
      })
      .finally(function() {
        app.hideLoader();
        ctrl.updateList();
      });
  };
  
  ctrl.getFieldShapeExport = function() {
	  getFieldShapeExport();
  };

  ctrl.getFieldNotes = function() {
      getFieldNotes();
  };

  ctrl.updateFieldNotes = function() {
      updateFieldNotes();
  };

  ctrl.getFieldBiodiversityData = function() {
    getFieldBiodiversityData();
  };

  ctrl.updateFieldIntensityBarto = function() {
	updateFieldIntensityBarto();
  };
  
  ctrl.updateFieldBiodiversityData = function() {
    updateFieldBiodiversityData();
  };

  function getDeletedIds(selectedFieldIds, failed) {
    let deletedIds = [];
    for (var i = 0; i < selectedFieldIds.length; i++) {
      let add = true;
      for (var j = 0; j < failed.length; j++) {
        for (var k = 0; k < failed[j].fieldIds.length; k++) {
          if (selectedFieldIds[i] == failed[j].fieldIds[k]) {
            add = false;
          }
        }
      }
      if (add) {
        deletedIds.push(selectedFieldIds[i]);
      }
    }
    return deletedIds;
  }

  function getSelectedFields() {
    return _.pluck(
      _.filter(ctrl.listData, function(item) {
        return item.$cfngrid_selected;
      }),
      'id'
    );
  }

  function createSummaryInformation(failedObjects) {
    let failedInfos = [];
    _.each(failedObjects, function(failed) {
      let failedInfo = {};
      failedInfo.messageKey = failed.messageKey;
      failedInfo.fieldNames = _.map(failed.fieldIds, function(id) {
        let field = _.find(ctrl.listData, function(item) {
          return item.id === id;
        });
        if (field) {
          return field.name;
        }
      });
      failedInfos.push(failedInfo);
    });

    return failedInfos;
  }

  function performFieldDeletion(fieldId) {
    fieldService
      .deleteFields([fieldId])
      .then(function(response) {
        $rootScope.$emit('deleteFields', [fieldId]);
        let data = response.data;
        if (data.deletedCount === 1) {
          // check against 1 since we only passed one single field
          ctrl.details = undefined;
          $scope.details = undefined;
          ctrl.resetDetails(true);
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter('fe.common.deleteSuccess', 'Erfolgreich gelöscht'),
            'success'
          );
        } else {
          // error -> take the first message key since for single deletion there's always only 1 message avaiable
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(data.failed[0].messageKey, 'Error'),
            'error'
          );
        }
      })
      .catch(function(error) {
        $rootScope.alertController.addTemporaryAlert(error.message, 'error');
      });
  }

  function arrayContains(needle, arrhaystack) {
    return arrhaystack.indexOf(needle) > -1;
  }

  function getFieldShapeExport(){
      let selectedFields = getSelectedFields();
      trackEvent('Fields','Button::FieldExport::Clicked', 'ExportedFields::TotalNumber', selectedFields.length);
      trackEvent('Fields','Button::FieldExport::Clicked', 'ExportedFields::WithoutGeometry', getNumberOfSelectedFieldWithoutGeom(selectedFields));
      $log.log("Field export - selected fields: "+JSON.stringify(selectedFields));
      fieldService
      .getFieldShapes(selectedFields)
      .then(
          function(response) {
              const blob = new Blob([response.data], {type: 'application/octet-stream'});
              const now = new Date();
              const today = formatDate(now, 'yyyy-MM-dd', 'en');
              const filename = 'fieldexport_'+today+'.zip';
              saveAs(blob, filename);
          },
          function(error) {
              $rootScope.alertController.addTemporaryAlert(
                  i18nFilter('fe.field.export.error', 'An error occurred while exporting fields.'),
                  'error'
              );
              $log.log('ERROR retrieving field shapes:', error);
          }
      );
  }

  function getNumberOfSelectedFieldWithoutGeom (selectedFields) {
    let noGeomCount = 0;
    for (let i in ctrl.listData) {
      if (selectedFields.indexOf(ctrl.listData[i].id) > -1 && !ctrl.listData[i].hasOwnProperty('geometry')) {
        noGeomCount++;
      }
    }
    return noGeomCount;
  }

  function getFieldNotes() {
    fieldService
      .getFieldNotes($scope.details.field.id)
      .then(
        function(response){
          ctrl.notes = response.data.note;
        },
        function(error){
          $rootScope.alertController.addTemporaryAlert(
              i18nFilter('fe.core.assets.field.notes.error.get'),
              'error'
          );
          $log.log('ERROR getting field notes: ', error);
        }
      );
  }

  function updateFieldNotes() {
    fieldService
      .updateFieldNotes($scope.details.field.id, ctrl.notes)
      .then(
        function(response){
          $rootScope.alertController.addTemporaryAlert(
              i18nFilter('fe.common.savedMsg', 'Änderungen gespeichert'), 'success'
          );
          $log.log('SUCCESS updating field notes!');
        },
        function(error){
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter('fe.core.assets.field.notes.error.update'), 'error'
          );
          $log.log('ERROR updating field notes: ', error);
        }
      );
  }

  function getFieldBiodiversityData() {
    setIsGrasslandOrPastureToScope()
    fieldService
      .getFieldBiodiversityData($scope.details.field.id)
      .then(
        function(response){
          if(response.status===204) {
            ctrl.fieldBiodiversityData = getDefaultFieldBiodiversityData();
          } else {
            ctrl.fieldBiodiversityData =  response.data;
          }
          if (ctrl.isSwissBartoUser) ctrl.updateFieldIntensityBarto();
        },
        function(error){
          ctrl.fieldBiodiversityData =  getDefaultFieldBiodiversityData();
          $rootScope.alertController.addTemporaryAlert(
              i18nFilter('fe.core.assets.fieldBiodiversityData.error.get'), 'error'
          );
          $log.log('ERROR getting field biodiversity data: ', error);
        }
      );
  }

  function setIsGrasslandOrPastureToScope() {
    const fieldUsage = $scope.details.field.usage;
    $scope.isGrasslandOrPasture = fieldUsage === 'GRASSLAND' || fieldUsage === 'PASTURE';
  }

  function updateFieldIntensityBarto() {
    setIsGrasslandOrPastureToScope();
    const fieldUsage = $scope.details.field.usage;
    if (fieldUsage === 'GRASSLAND' || fieldUsage === 'PASTURE') {
      if (ctrl.fieldBiodiversityData && !ctrl.fieldBiodiversityData.intensityType) {
        ctrl.fieldBiodiversityData.intensityType = 'INTENSIVE';
        ctrl.updateFieldBiodiversityData();
      }
    } else {
      if (ctrl.fieldBiodiversityData && ctrl.fieldBiodiversityData.intensityType) {
        ctrl.fieldBiodiversityData.intensityType = undefined;
        ctrl.updateFieldBiodiversityData();
      }
    }
  }


  function updateFieldBiodiversityData() {
    fieldService
      .updateFieldBiodiversityData($scope.details.field.id, ctrl.fieldBiodiversityData)
      .then(
        function(response){
          $rootScope.alertController.addTemporaryAlert(
              i18nFilter('fe.common.savedMsg', 'Änderungen gespeichert'), 'success'
          );
          $log.log('SUCCESS updating field biodiversity data!');
        },
        function(error){
          $rootScope.alertController.addTemporaryAlert(
              i18nFilter('fe.core.assets.fieldBiodiversityData.error.update'), 'error'
          );
          $log.log('ERROR updating field biodiversity data: ', error);
        }
      );
  }

  function getDefaultFieldBiodiversityData() {
    return {
      biodiversityType: 'EMPTY',
      fruitTreeCount: undefined,
      endemicTreeCount: undefined,
      intensityType: undefined,
      biodiversityNotes: ''
    }
  }

  let specialAdd = (mode.specialAdd = []);
  let ele = null;
  ele = {};
  ele.property = 'possession';
  ele.Property = 'Possession';
  specialAdd.push(ele);
  ele = {};
  ele.property = 'fieldGroups';
  ele.Property = 'FieldGroups';
  specialAdd.push(ele);

  ctrl.addGroupsByField = function() {
    return (elements) => {
      ctrl.callRest('addFieldGroupsByIdMultiple/' + $scope.details.field.id ) (elements);
    };
  };

  ctrl.addPossessionsByField = function() {
    return (elements) => {
      ctrl.callRest('/addPossessionByIdMultiple/' + $scope.details.field.id ) (elements);
    };
  };

  
  // validation engine
  let vgi = {};
  vgi['active'] = '1';
  vgi['name'] = '1';
  vgi['farm'] = '1';
  vgi['number'] = '1';
  vgi['officialId'] = '1';
  vgi['administrative_region'] = '1';
  vgi['possession'] = '1';
  vgi['usage'] = '1';
  vgi['geoArea'] = '1';
  vgi['farmedArea'] = '1';
  vgi['fieldGroups'] = '1';
  vgi['geometry'] = '1';
  vgi['cropSequence'] = '2';
  vgi['soilType'] = '3';
  vgi['plateNumber'] = '3';
  vgi['fieldValue'] = '3';
  vgi['emzValue'] = '8';
  vgi['erosionClass'] = '3';
  vgi['waterReserve'] = '3';
  vgi['waterprotectionzone'] = '3';
  vgi['drained'] = '3';
  vgi['soilCondition'] = '3';
  vgi['waterSupply'] = '3';
  vgi['currentCrop'] = '3';
  vgi['currentSeed'] = '3';
  vgi['distanceRestriction_PERIODICALWATERBEARING'] = '3';
  vgi['distanceRestriction_OCCASIONALLYWATERBEARING'] = '3';
  vgi['distanceRestriction_PROTECTEDSEAMSTRUCTURE'] = '3';
  vgi['distanceRestriction_UNPROTECTEDSEAMSTRUCTURE'] = '3';
  vgi['areaType'] = '3';
  mode.vgi = vgi;



  return coreCommonController(
    'field',
    ctrl,
    mode,
    $scope,
    $rootScope,
    CoreREST,
    Field,
    $http,
    $timeout,
    $log,
    $dialog,
    $injector,
    $route,
    FavoriteService,
    i18nFilter
  );
}
